// extracted by mini-css-extract-plugin
export var chip = "_mm-2";
export var chipBody = "_mm-8";
export var chipHeader = "_mm-9";
export var chipWithKind = "_mm-7";
export var icon = "_mm-3";
export var kind = "_mm-a";
export var remove = "_mm-5";
export var removeIcon = "_mm-6";
export var row = "_mm-0";
export var rowHistorical = "_mm-1";
export var text = "_mm-4";